export { default as CompanyQRCode } from './CompanyQRCode';
export { default as ProfileLogo } from './ProfileLogo';
export { default as fragment } from './companyProfileFragment';
